<template>
  <v-col :cols="qtdColunas">
    <v-card
      :outlined="celulaOptions.outlined"
      :elevation="celulaOptions.elevation"
      :class="cardClasses"
    >
      <configurar-componente-dialog
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :componente-data="state.componenteData"
        @refetch-data="$emit('refetch-data')"
      />

      <deletar-componente-dialog
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        :secao-id="celulaComponenteOptions.idFormularioSecao"
        :componente-id="celulaComponenteOptions.id"
        @refetch-data="$emit('refetch-data')"
      />

      <blank
        v-if="isBlank"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :label="celulaComponenteOptions.label"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
      />

      <text-field
        v-else-if="isTextField"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :value-text="celulaComponenteOptions.valueText"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <text-area
        v-else-if="isTextArea"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :value-text="celulaComponenteOptions.valueText"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <checkbox
        v-else-if="isCheckbox"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :label="celulaComponenteOptions.label"
        :value-boolean="celulaComponenteOptions.valueBoolean"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <radio-group
        v-else-if="isRadioGroup"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :opcoes="celulaComponenteOptions.opcoes"
        :value-opcao-selecionada-id="celulaComponenteOptions.valueOpcaoSelecionadaId"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <drop-down-list
        v-else-if="isDropdownList"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :opcoes="celulaComponenteOptions.opcoes"
        :value-opcao-selecionada-id="celulaComponenteOptions.valueOpcaoSelecionadaId"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <drop-down-list-encadeado
        v-else-if="isDropdownListEncadeado"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :opcoes="celulaComponenteOptions.opcoes"
        :componente-data="state.componenteData"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, opt.componenteId, opt.componenteTipoId, opt.label)"
      />

      <botao-email
        v-else-if="isBotaoEmail"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :label="celulaComponenteOptions.label"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
      />

      <text-label
        v-else-if="isLabel"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :label="celulaComponenteOptions.label"
        :texto="celulaComponenteOptions.texto"
        :text-label-options="componenteTextLabelOptions"
        :value-text="celulaComponenteOptions.valueText"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
      />

      <arquivo
        v-else-if="isArquivo"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :componente-arquivo-options="componenteArquivoOptions"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <assinatura
        v-else-if="isAssinatura"
        :componente-assinatura-options="componenteAssinaturaOptions"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />

      <numerico
        v-else-if="isNumerico"
        :filled="celulaComponenteOptions.filled"
        :disabled="celulaComponenteOptions.disabled"
        :readonly="celulaComponenteOptions.readonly"
        :mostrar-icones="celulaComponenteOptions.mostrarIcones"
        :obrigatorio="celulaComponenteOptions.obrigatorio"
        :label="celulaComponenteOptions.label"
        :max-length="celulaComponenteOptions.maxLength"
        :value-text="celulaComponenteOptions.valueText"
        :componente-numerico-subtipo-id="celulaComponenteOptions.componenteNumericoSubtipoId"
        :regex1="celulaComponenteOptions.componenteNumericoSubtipo.regex1"
        :regex2="celulaComponenteOptions.componenteNumericoSubtipo.regex2"
        :is-configurar-celula-dialog-open.sync="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open.sync="isDeletarComponenteDialogOpen"
        @input-changed="opt => celulaOptions.handleInputChange(opt.value, celulaComponenteOptions.id, celulaComponenteOptions.idElementoTipo, celulaComponenteOptions.label)"
      />
    </v-card>
  </v-col>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import ConfigurarComponenteDialog from '@/views/formulario/componentes/configurar-componente-dialog/ConfigurarComponenteDialog.vue'
import DeletarComponenteDialog from '@/views/formulario/componentes/deletar-componente-dialog/DeletarComponenteDialog.vue'
import Blank from '@/views/formulario/componentes/Blank.vue'
import TextField from '@/views/formulario/componentes/TextField.vue'
import TextArea from '@/views/formulario/componentes/TextArea.vue'
import Checkbox from '@/views/formulario/componentes/Checkbox.vue'
import RadioGroup from '@/views/formulario/componentes/RadioGroup.vue'
import DropDownList from '@/views/formulario/componentes/DropDownList.vue'
import DropDownListEncadeado from '@/views/formulario/componentes/DropDownListEncadeado.vue'
import BotaoEmail from '@/views/formulario/componentes/BotaoEmail.vue'
import TextLabel from '@/views/formulario/componentes/TextLabel.vue'
import Arquivo from '@/views/formulario/componentes/Arquivo.vue'
import Assinatura from '@/views/formulario/componentes/Assinatura.vue'
import Numerico from '@/views/formulario/componentes/Numerico.vue'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'
import ComponenteTextLabelOptions from '@/models/props/ComponenteTextLabelOptions'
import ComponenteAssinaturaOptions from '@/models/props/ComponenteAssinaturaOptions'
import CelulaComponenteOptions from '@/models/props/CelulaComponenteOptions'
import CelulaOptions from '@/models/props/CelulaOptions'
import ComponenteArquivoOptions from '@/models/props/ComponenteArquivoOptions'

export default {
  components: {
    ConfigurarComponenteDialog,
    DeletarComponenteDialog,
    Blank,
    TextField,
    TextArea,
    Checkbox,
    RadioGroup,
    DropDownList,
    DropDownListEncadeado,
    BotaoEmail,
    TextLabel,
    Arquivo,
    Assinatura,
    Numerico,
  },

  props: {
    componenteData: {
      type: Object,
      required: true,
    },
    celulaOptions: {
      type: CelulaOptions,
      required: true,
    },
    celulaComponenteOptions: {
      type: CelulaComponenteOptions,
      required: true,
    },
    componenteAssinaturaOptions: {
      type: ComponenteAssinaturaOptions,
      default: null,
    },
    componenteTextLabelOptions: {
      type: ComponenteTextLabelOptions,
      default: null,
    },
    componenteArquivoOptions: {
      type: ComponenteArquivoOptions,
      default: null,
    },
  },

  setup(props) {
    const isConfigurarCelulaDialogOpen = ref(false)
    const isDeletarComponenteDialogOpen = ref(false)

    const state = ref({})
    const idElementoTipo = ref(0)
    watch(() => [props.componenteData, props.celulaOptions.qtdColunasPorCelula], value => {
      state.value = { componenteData: value[0], qtdColunasPorCelula: value[1] }
      idElementoTipo.value = state.value.componenteData.idElementoTipo
    }, { immediate: true, deep: true })

    const isBlank = computed(() => idElementoTipo.value === TiposDeComponentesEnum.Blank)
    const isTextBox = computed(() => idElementoTipo.value === TiposDeComponentesEnum.TextBox)
    const isTextField = computed(() => isTextBox.value && !state.value.componenteData.multiline)
    const isTextArea = computed(() => isTextBox.value && state.value.componenteData.multiline)
    const isRadioGroup = computed(() => idElementoTipo.value === TiposDeComponentesEnum.RadioGroup)
    const isCheckbox = computed(() => idElementoTipo.value === TiposDeComponentesEnum.CheckBox)
    const isDropdownList = computed(() => idElementoTipo.value === TiposDeComponentesEnum.DropDownList)
    const isDropdownListEncadeado = computed(() => idElementoTipo.value === TiposDeComponentesEnum.DropDownListEncadeado)
    const isBotaoEmail = computed(() => idElementoTipo.value === TiposDeComponentesEnum.BotaoEmail)
    const isLabel = computed(() => idElementoTipo.value === TiposDeComponentesEnum.Label)
    const isArquivo = computed(() => idElementoTipo.value === TiposDeComponentesEnum.Arquivo)
    const isAssinatura = computed(() => idElementoTipo.value === TiposDeComponentesEnum.Assinatura)
    const isNumerico = computed(() => idElementoTipo.value === TiposDeComponentesEnum.Numerico)

    const qtdColunas = computed(() => {
      let qtd = state.value.qtdColunasPorCelula

      if (isTextArea.value) {
        qtd = 4
      } else if (isDropdownListEncadeado.value) {
        qtd = 6
      } else if (isArquivo.value) {
        qtd = 3
      } else if (isLabel.value || !isBlank.value) {
        qtd = 'auto'
      }

      return qtd
    })

    const cardClasses = computed(() => {
      let classes = ''

      if (props.celulaOptions.usePadding) {
        classes += 'pl-1 pr-2 py-2'
      }
      if (props.celulaOptions.justifyCenter) {
        classes += ' d-flex justify-center align-center'
      }

      return classes
    })

    return {
      state,
      isConfigurarCelulaDialogOpen,
      isDeletarComponenteDialogOpen,
      isBlank,
      isTextField,
      isTextArea,
      isRadioGroup,
      isCheckbox,
      isDropdownList,
      isDropdownListEncadeado,
      isBotaoEmail,
      isLabel,
      isArquivo,
      isAssinatura,
      isNumerico,
      qtdColunas,
      cardClasses,
    }
  },
}
</script>
